import React, { useState, useEffect, useRef } from 'react';
import {
  LayoutSelectorContainer,
  Dropdown,
  DropdownItem,
  IconButton,
  LayoutIcon,
  FaBarsIcon,
  FaWindowMaximizeIcon,
  LayoutSelectorContent
} from './styled';
import { Popover, PopoverBody } from 'reactstrap';
import { FaColumns } from 'react-icons/fa';
const BASE_ICON_COLOR = '#525f7f';

const LayoutSelector = ({
  selectedLayout,
  onLayoutChange,
  systemConfiguration
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setPopoverOpen(false);
  };

  const togglePopover = () => {
    if (!isOpen) {
      setPopoverOpen(!popoverOpen);
    }
  };

  const handleLayoutChange = (layout) => {
    onLayoutChange(layout);
    setIsOpen(false);
  };

  const getIcon = () => {
    switch (selectedLayout) {
      case 'modal':
        return <FaWindowMaximizeIcon color={BASE_ICON_COLOR} />;
      // case 'sidebar': // Commented out as it will be removed later
      //   return <FaColumnsIcon color={BASE_ICON_COLOR} />;
      default:
        return <FaBarsIcon color={BASE_ICON_COLOR} />;
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setPopoverOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedColor = `${systemConfiguration.primary_color}33`;

  return (
    <LayoutSelectorContainer ref={dropdownRef}>
      <IconButton
        id="IconButtonPopover"
        onClick={toggleDropdown}
        onMouseEnter={togglePopover}
        onMouseLeave={togglePopover}
        isActive={isOpen}
      >
        {getIcon()}
      </IconButton>
      <Popover
        placement="bottom"
        isOpen={popoverOpen}
        target="IconButtonPopover"
        toggle={togglePopover}
      >
        <PopoverBody>Alterar layout</PopoverBody>
      </Popover>
      <Dropdown isOpen={isOpen}>
        <LayoutSelectorContent>
          <DropdownItem
            onClick={() => handleLayoutChange('modal')}
            selected={selectedLayout === 'modal'}
            selectedColor={selectedColor}
          >
            <LayoutIcon color={BASE_ICON_COLOR}>
              <FaWindowMaximizeIcon />
            </LayoutIcon>
            <span>Padrão</span>
          </DropdownItem>
          <DropdownItem
            onClick={() => handleLayoutChange('sidedrawer')}
            selected={selectedLayout === 'sidedrawer'}
            selectedColor={selectedColor}
          >
            <LayoutIcon color={BASE_ICON_COLOR}>
              <FaColumns />
            </LayoutIcon>
            <span>Tela lateral</span>
          </DropdownItem>
        </LayoutSelectorContent>
      </Dropdown>
    </LayoutSelectorContainer>
  );
};

export default LayoutSelector;
